import {
  faPlus,
  faTrash,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons" 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux" 

import { apiRoute, linksUrl } from "../../constants/enum.js" 
import { useDelete, useFetchWithBody } from "../../api/reactQueryCustomHooks.jsx"
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components/index.js"
import { resetMenuMaster, setSelectedMenu } from "../../state/menuMasterSlice.js"
import { COLUMN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable.jsx"

function MenuMaster() {
  const navigate = useNavigate()
  const dispatch = useDispatch() 
  const { selectedApp } = useSelector((state) => state.appMaster) 
  const { mutate: deleteMenuMaster } = useDelete({
    url: apiRoute.menuMaster.delete,
    queryKey: "MenuMaster",
  })

  /*  */
  const exportColumns = [
    { uid: "AppId", name: "App Id" },
    { uid: "MenuId", name: "Menu Id" },
    { uid: "MenuName", name: "Menu Name" },
    { uid: "MenuParentId", name: "Menu Parent Id" },
    { uid: "Level", name: "Level" },
  ]

  /*  */
  const onClickEdit = (item) => {
    dispatch(setSelectedMenu(item))
    navigate(linksUrl.menuMaster.edit)
  }

  const onClickDelete = (item) => {
    deleteMenuMaster({
      data: {
        menuId: item.MenuId,
        appId: item.AppId, 
      },
    })
  }

  const onClickPrevPage = () => {
    dispatch(resetMenuMaster())
    navigate(linksUrl.appMaster.read)
  }

  const {
    isLoading,
    isError,
    data = [],
  } = useFetchWithBody({
    url: apiRoute.menuMaster.read,
    queryKey: "MenuMaster",
    inputData: {
      appId: selectedApp.AppId,
      menuId: null,
      option: 1,
    },
  })

  const columns = [
    { uid: "Level", name: "Level", type: COLUMN_TYPE.chip},
    { uid: "MenuName", name: "Menu Name" },
    {
      name: "ACTIONS",
      uid: "actions",
    },
  ]

  const INITIAL_VISIBLE_COLUMNS = ["Level", "MenuName", "actions"]

  const topActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPlus} />,
      onClick: () => {
        navigate(linksUrl.menuMaster.add)
      },
      label: "Add Menu", 
    },
  ]

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPenToSquare} />,
      onClick: onClickEdit,
      label: "Edit",
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon icon={faTrash} />,
      onClick: onClickDelete,
      label: "Delete",
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]

  

  if (isLoading) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer
        pageName="Menu Master"
        breadcrumbs={["App Master", "Menu Master"]}
        info={[["App", selectedApp.AppName]]}
        prevPage={{
          show: true,
          onClick: onClickPrevPage,
        }}
      >
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          topActionBtn={topActionBtn}
          rowActionBtn={rowActionBtn}
          
          downloadFileName="Menu_Master"
          id="MenuId"
        />
      </MainContainer>
    </div>
  )
}

export default MenuMaster
